var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Family-Playmate"},[_c('div',{staticClass:"Family-Playmate-img-wrap"},[_c('img',{staticClass:"Family-Playmate-img",attrs:{"src":"https://mediakit.enabot.com/eboX/img/pc/yourFamilyPlaymate_img@2x.png","alt":""}})])])
}]

export { render, staticRenderFns }